import React from 'react';
import "./marquee.scss";

const logos = [
  "1.png", "2.png", "3.png", "4.png", "5.png", "6.png",
  "7.png", "8.png", "9.png", "10.png", "11.png", "12.png"
];

const Marquee = () => {
  return (
    <div className='marque_div'>
      <h3>Trusted By Clients Across Industries</h3>
      <div className="marquee-wrapper">
        <div className="marquee">
          <div className="marquee__group">
            {logos.map((logo, index) => (
              <img key={index} src={`/assets/${logo}`} alt={`logo-${index}`} className="imgunder" />
            ))}
          </div>
          <div className="marquee__group" aria-hidden="true">
            {logos.map((logo, index) => (
              <img key={`dup-${index}`} src={`/assets/${logo}`} alt={`logo-dup-${index}`} className="imgunder" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marquee;
